import axios from "axios";
import { getConsent } from "./consent";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
const STORAGE_UTM = "equisight_utm";
const STORAGE_SESSION = "equisight_session";

const safeWindow = () => (typeof window !== "undefined" ? window : null);

const parseQuery = () => {
  const w = safeWindow();
  if (!w) return {};
  const params = new URLSearchParams(w.location.search);
  const out = {};
  UTM_KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) out[k] = v;
  });
  // Shorthand: ?utm=foo treated as utm_campaign
  if (!out.utm_campaign && params.get("utm")) {
    out.utm_campaign = params.get("utm");
  }
  return out;
};

export const captureUTM = () => {
  const w = safeWindow();
  if (!w) return {};
  const fresh = parseQuery();
  if (Object.keys(fresh).length > 0) {
    w.sessionStorage.setItem(STORAGE_UTM, JSON.stringify(fresh));
    return fresh;
  }
  try {
    return JSON.parse(w.sessionStorage.getItem(STORAGE_UTM) || "{}");
  } catch {
    return {};
  }
};

export const getUTM = () => {
  const w = safeWindow();
  if (!w) return {};
  try {
    return JSON.parse(w.sessionStorage.getItem(STORAGE_UTM) || "{}");
  } catch {
    return {};
  }
};

export const getSessionId = () => {
  const w = safeWindow();
  if (!w) return null;
  let id = w.sessionStorage.getItem(STORAGE_SESSION);
  if (!id) {
    id =
      (w.crypto?.randomUUID && w.crypto.randomUUID()) ||
      `s_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
    w.sessionStorage.setItem(STORAGE_SESSION, id);
  }
  return id;
};

export const track = (eventType, { label, page, props } = {}) => {
  const w = safeWindow();
  if (!w) return;
  // Respect cookie consent: only analytics events when allowed.
  // 'waitlist_signup' fires server-side from /api/waitlist regardless.
  const consent = getConsent();
  if (!consent.analytics) return;
  const body = {
    event_type: eventType,
    page: page ?? w.location.pathname,
    label,
    session_id: getSessionId(),
    utm: getUTM(),
    props,
  };
  // Fire-and-forget; don't block UI on tracking failures
  axios.post(`${API}/events`, body).catch(() => {});
};
